/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPagedSyncEntities} from '../api'

 export const useQueryGetPagedSyncEntities = createReactQueryHook('getPagedSyncEntities', getPagedSyncEntities)
